import { render } from "./OrgStructureManagement.vue?vue&type=template&id=ffbbb524&scoped=true"
import script from "./OrgStructureManagement.vue?vue&type=script&lang=js"
export * from "./OrgStructureManagement.vue?vue&type=script&lang=js"

import "./OrgStructureManagement.vue?vue&type=style&index=0&id=ffbbb524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbbb524"]])

export default __exports__